
// 特殊处理txt类型的文件 
export  function fileUrl(url){
  let isTxt = getFileType(url)
  if (isTxt) {
    return ''
  } else { 
    return url
  }
}
export function getFileType(url){
  let urlList = [ 'txt']
  let urlArr = url.split('.')
  let urlType = urlArr[urlArr.length - 1]
  return urlList.indexOf(urlType) > -1
}

// 下载
export function downloadTxt(url, fileName) {
  const x = new XMLHttpRequest()
  x.open('GET', url, true)
  x.responseType = 'blob'
  x.onload = () => {
    const url = window.URL.createObjectURL(x.response)
    createAndRemove(url, fileName)
  }
  x.send()
}
function createAndRemove(url, fileName) {
  // 创建隐藏的可下载链接
  var eleLink = document.createElement('a')
  eleLink.download = fileName
  eleLink.style.display = 'none'
  // 下载内容转变成blob地址
  eleLink.href = url
  // 触发点击
  document.body.appendChild(eleLink)
  eleLink.click()
  // 然后移除
  document.body.removeChild(eleLink)
}


